import React, { FunctionComponent, useMemo } from 'react'
import { ColorsV2TagBackground } from '../../../../design-system/colors_v2'
import { Tag } from '../Tag'
import { TagCollectionProps } from './TagCollection.model'
import { useGetTags } from '../../../../hooks/queries/tag'

export const TagCollection: FunctionComponent<TagCollectionProps> = ({ ids, limit = 4 }) => {
  const { tagList: resources } = useGetTags()

  const tags = useMemo(
    () =>
      ids
        .map((id) => resources.find((resource) => resource.id === id))
        .filter(Boolean)
        .filter((_, index) => index < limit),
    [ids, resources, limit],
  )
  const more = useMemo(
    () =>
      ids.length > limit ? (
        <Tag color={ColorsV2TagBackground.dsTag00} testId={`tag_collection-remaining_tags-number`}>
          +{ids.length - limit} label{ids.length - limit > 1 ? 's' : ''}
        </Tag>
      ) : null,
    [ids.length, limit],
  )
  return (
    <>
      {tags.map(
        (value, key) =>
          value && (
            <Tag
              key={key}
              color={value.color}
              title={value.label}
              testId={`tag_collection-${value.id}`}
            >
              {value.label}
            </Tag>
          ),
      )}
      {more}
    </>
  )
}
